// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DataHandling_wrapper__2751l"};